import React from "react";
import "./Project.css";
import images from "../../images/index";
import { RiExternalLinkLine, RiGithubFill } from "react-icons/ri";

const project = () => {
  return (
    <>
      <section id="projects">
        <div className="project-container">
          <div className="project-title">
            <p>Portfolio</p>
            <h2>
              <span>Creative</span> Work
            </h2>
          </div>
          <div className="pro">
            <div className="pro-img">
              <a href="https://content-generation-system.onrender.com/">
                <img src={images.contentgen} alt="Content Generation System" />
              </a>
            </div>
            <div className="pro-text">
              <h2>Content Generation System - Gen AI</h2>
              <p>
              AI-powered SaaS platform enabling intelligent content creation, image generation, and data visualization. Features secure authentication, subscription access, and a scalable backend. Recognized through publication in a reputed research journal.
              </p>
              <div className="tools">
                <p>Typescript</p>
                <p>ShadCN</p>
                <p>Next.js</p>
                <p>API Integration</p>
                <p>PostgreSQL</p>
              </div>
              <div className="links">
                <a
                  href="https://github.com/hrithikksingh3/Content-generation-system"
                  target="_blank"
                >
                  <p>Github</p>
                  <RiGithubFill />
                </a>
                <a
                  href="https://content-generation-system.onrender.com/"
                  target="_blank"
                >
                  <p>Live</p>
                  <RiExternalLinkLine />
                </a>
              </div>
            </div>
          </div>
          <div className="pro pro-inverse">
            <div className="pro-text">
              <h2>AasaanSEND</h2>
              <p>
              AasaanSEND is a Real-time file sharing app with secure room-based transfers and instant communication via WebSockets. Features a responsive green-white UI for seamless cross-device file exchange.
              </p>
              <div className="tools">
                <p>HTML</p>
                <p>CSS</p>
                <p>Javascript</p>
                <p>Node.js</p>
                <p>Socket.io</p>
              </div>
              <div className="links">
                <a
                  href="https://github.com/hrithikksingh3/AasaanSend"
                  target="_blank"
                >
                  <p>Github</p>
                  <RiGithubFill />
                </a>
                <a href="https://aasaansend.onrender.com/" target="_blank">
                  <p>Live</p>
                  <RiExternalLinkLine />
                </a>
              </div>
            </div>
            <div className="pro-img">
              <a href="https://aasaansend.onrender.com/">
                <img src={images.aasaansend} alt="AasaanSEND" />
              </a>
            </div>
          </div>
          <div className="pro">
            <div className="pro-img pro-img2">
              <a href="https://primemax-1.onrender.com/">
                <img src={images.primemax} alt="Primemax" />
              </a>
            </div>
            <div className="pro-text">
              <h2>Primemax</h2>
              <p>
              Full-stack streaming platform inspired by Netflix with user authentication, secure APIs, and a modern UI. Features movie browsing, session management with JWT, and global state handling via Redux.
              </p>
              <div className="tools">
                <p>React.js</p>
                <p>Tailwind CSS</p>
                <p>Node.js</p>
                <p>MongoDb</p>
                <p>JWT</p>
              </div>
              <div className="links">
                <a
                  href="https://github.com/hrithikksingh3/PRIMEMAX"
                  target="_blank"
                >
                  <p>Github</p>
                  <RiGithubFill />
                </a>
                <a href="https://primemax-1.onrender.com/" target="_blank">
                  <p>Live</p>
                  <RiExternalLinkLine />
                </a>
              </div>
            </div>
          </div>
          <div className="pro pro-inverse">
            <div className="pro-text">
              <h2>Cardiovascular Risk Predictor</h2>
              <p>
              A Web App that leverages machine learning to estimate your 10-year risk of coronary heart disease (CHD). The app predicts risk based on the Framingham Heart Study dataset, offering valuable insights into heart health.
              </p>
              <div className="tools">
                <p>python</p>
                <p>Streamlit</p>
                <p>Pandas</p>
                <p>Framingham DS</p>
              </div>
              <div className="links">
                <a href="https://github.com/hrithikksingh3/Cardiovascular-Risk-Prediction-Web-APP" target="_blank">
                  <p>Github</p>
                  <RiGithubFill />
                </a>
                <a href="https://cardiovascular-risk-prediction-bfc1.onrender.com/" target="_blank">
                  <p>Live</p>
                  <RiExternalLinkLine />
                </a>
              </div>
            </div>
            <div className="pro-img pro-img3">
              <a href="https://cardiovascular-risk-prediction-bfc1.onrender.com/">
                <img src={images.cardio} alt="CardioVascular Risk predictor" />
              </a>
            </div>
          </div>

          <div className="pro">
            <div className="pro-img pro-img2">
              <a href="https://coding-school-landing-page.onrender.com/">
                <img src={images.codersvoice} alt="Codersvoice" />
              </a>
            </div>
            <div className="pro-text">
              <h2>Codersvoice</h2>
              <p>
              Designed and developed a static landing page for a coding website - Codersvoice with a clean, responsive layout and interactive elements.
              </p>
              <div className="tools">
                <p>HTML</p>
                <p>CSS</p>
                <p>Javascript</p>
              </div>
              <div className="links">
                <a
                  href="https://github.com/hrithikksingh3/Coding-school-Landing-page"
                  target="_blank"
                >
                  <p>Github</p>
                  <RiGithubFill />
                </a>
                <a href="https://coding-school-landing-page.onrender.com/" target="_blank">
                  <p>Live</p>
                  <RiExternalLinkLine />
                </a>
              </div>
            </div>
          </div>

        </div>
      </section>
    </>
  );
};

export default project;
